import React from "react";
// import { ContentWithCardLoading } from "../../components/loading";
import { Redirect, Route, Switch } from "react-router-dom";
import GatewayAndPriceListEmail from "./container/gateway-and-price-list-email";
import GatewayAndPriceListSms from "./container/gateway-and-price-list-sms";
import gatewayAndPriceListWhatsapp from "./container/gateway-and-price-list-whatsapp";
import WhatsappPrice2List from "./container/gateway-and-price-list-whatsapp-2";
import RCSPriceList from "./container/gateway-and-proce-list-rcs";

export default function GatewayAndPriceRoutes({ match }) {
  return (
    <Switch>
      <Route exact path={`${match.url}/sms`} component={GatewayAndPriceListSms} />
      <Route exact path={`${match.url}/email`} component={GatewayAndPriceListEmail} />
      <Route exact path={`${match.url}/whatsapp`} component={gatewayAndPriceListWhatsapp} />
      <Route exact path={`${match.url}/whatsapp-2`} component={WhatsappPrice2List} />
      <Route exact path={`${match.url}/rcs`} component={RCSPriceList} />
      <Redirect to={`${match.url}/sms`} />
    </Switch>
  );
}
